import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangePasswordComponent } from './change-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DxButtonModule, DxCheckBoxModule, DxDateBoxModule, DxPopupModule, DxSelectBoxModule, DxSliderModule, DxTextAreaModule, DxTextBoxModule, DxValidationSummaryModule, DxValidatorModule } from 'devextreme-angular';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';



@NgModule({
	declarations: [ChangePasswordComponent],
	exports: [ChangePasswordComponent],
	imports: [
		CommonModule,
		DevEpressCommonModule,
		DxPopupModule,
		DxTextAreaModule,
		DxValidatorModule,
		DxValidationSummaryModule,
		DxDateBoxModule,
		DxSliderModule,
		FormsModule,
		ReactiveFormsModule,
		DxSelectBoxModule,
		DxCheckBoxModule,
		DxTextBoxModule,
		DxButtonModule
	]
})
export class ChangePasswordWidgetModule { }
